import React, {useEffect} from 'react'
import { Col, Row } from 'antd'
import { connect } from 'react-redux'
import Layout from '../../components/Layout'
import actions from '../../redux/actions'
import Divider from '../../components/Divider'
import styled from 'styled-components'

import subDistrictsData from '../../assets/data/subDistrict.json';

const Text = styled.p`
  font-size: 18px;
  line-height: 24.3px;
`

const StyledCol = styled(Col)`
  margin: 1rem 0 !important;
`

const SubDistrict = (props) => {
  const districtId = props.userInfomations.documentDistrictId;
  const handleClick = (id,value,zipcode) => {
    props.setDocumentSubDistrict(id,value)
    props.setDocumentZipcode(zipcode)
    props.history.go(-3)
  }

  useEffect(() => window.scrollTo(0,0));

  return (
    <Layout title={'ตำบล/แขวง'} backIcon={true} onClick={() => props.history.goBack()}>
      <h4 style={{marginTop: '2rem', marginBottom: '1rem'}}>กรุณาเลือกตำบล/แขวง</h4>
      <Row>
        {
          subDistrictsData.map(element => {
            if(districtId === element.district_id) {
              return (
                <StyledCol key={element.id}>
                <Text onClick={() => handleClick(element.id,element.th,element.zipcode)}>{element.th}</Text>
                <Divider floatRight={true}/>
              </StyledCol>
              )
            } else {
              return null
            }
          })
        }
      </Row>
    </Layout>
  )
}

const mapDispatchToProps = {
  setDocumentSubDistrict: actions.setDocumentSubDistrict,
  setDocumentZipcode: actions.setDocumentZipcode,
}

const mapStateToProps = (state) => {
  return {
    userInfomations: state.userInfomations
  }
}

const SubDistrictWithConnect = connect(mapStateToProps, mapDispatchToProps)(SubDistrict)

export default SubDistrictWithConnect
